module.exports = __webpack_public_path__ + "static/media/filter-selected.d86bac7f.svg";